var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isLoggedIn,
          expression: "isLoggedIn"
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "acc-page-holder" },
        [
          _vm.accountSummaryFlow
            ? [
                !_vm.mobileBigAndBelow
                  ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.W2G.Page.Title")))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileBigAndBelow && _vm.brandTemplate !== "generic_2"
                  ? _c(
                      "div",
                      { staticClass: "account-heading" },
                      [
                        _c("icon", { attrs: { name: "icon-w2g" } }),
                        _vm._v(_vm._s(_vm.$t("Account.W2G.Page.Title")))
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.accountSummaryFlow
            ? [_c("h1", [_vm._v(_vm._s(_vm.$t("Account.W2G.Page.Title")))])]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w2g-page" },
            [
              _c("DateRangePicker", {
                ref: "dateRangePicker",
                attrs: { infoText: _vm.$t("Account.W2G.Table.HistoryFrom") },
                on: { apply: _vm.onFilterApply }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "acc-page" }, [
                _vm.isLoading
                  ? _c(
                      "div",
                      { staticClass: "w2g-list-fetching-progress" },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "" }
                        })
                      ],
                      1
                    )
                  : _c("div", [
                      _vm.w2gTaxFormList.length > 0
                        ? _c("div", { staticClass: "txlist" }, [
                            _c(
                              "table",
                              { staticClass: "txtable" },
                              [
                                _c("tr", { staticClass: "tablehead" }, [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.W2G.Table.ColumnTitle.Seen"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.W2G.Table.ColumnTitle.BetId"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.W2G.Table.ColumnTitle.Created"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.W2G.Table.ColumnTitle.Winnings"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    { staticClass: "mobile-only-hidden" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.W2G.Table.ColumnTitle.FederalWithholding"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    { staticClass: "mobile-only-hidden" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.W2G.Table.ColumnTitle.StateWithholding"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showLocaltaxInW2gform
                                    ? _c(
                                        "th",
                                        { staticClass: "mobile-only-hidden" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Account.W2G.Table.ColumnTitle.TaxLocal"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    { staticClass: "mobile-only-visible" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.W2G.Table.ColumnTitle.Withholding"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.w2gTaxFormList, function(
                                  item,
                                  index
                                ) {
                                  return _c("tr", { key: index }, [
                                    _c(
                                      "td",
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "seen-checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            readonly: ""
                                          },
                                          model: {
                                            value: item.Seen,
                                            callback: function($$v) {
                                              _vm.$set(item, "Seen", $$v)
                                            },
                                            expression: "item.Seen"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "AuthFileDownloadLink",
                                          {
                                            attrs: {
                                              getAuthLink: function() {
                                                return _vm.getDownloadLinkForW2gPdf(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.Bet))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            item.Created,
                                            _vm.dateFormats.shortDate
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm._f("currency")(item.Winning))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "mobile-only-hidden" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(item.TaxFederal)
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "mobile-only-hidden" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(item.TaxState)
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.showLocaltaxInW2gform
                                      ? _c(
                                          "td",
                                          { staticClass: "mobile-only-hidden" },
                                          [
                                            item.TaxLocal !== null &&
                                            item.TaxLocal !== ""
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        item.TaxLocal
                                                      )
                                                    )
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "mobile-only-visible" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "tax-witholding-mobile"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tax-witholding-mobile-content"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        item.TaxFederal
                                                      )
                                                    ) + " F"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        item.TaxState
                                                      )
                                                    ) + " S"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.showLocaltaxInW2gform
                                                  ? _c(
                                                      "span",
                                                      [
                                                        item.TaxLocal !==
                                                          null &&
                                                        item.TaxLocal !== ""
                                                          ? [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "currency"
                                                                  )(
                                                                    item.TaxLocal
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" L")
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                })
                              ],
                              2
                            )
                          ])
                        : _c("div", { staticClass: "no-items-to-show" }, [
                            _c(
                              "p",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "info" }
                                  },
                                  [_vm._v("info")]
                                ),
                                _vm._v(
                                  _vm._s(_vm.$t("Account.W2G.NoItemsToShow"))
                                )
                              ],
                              1
                            )
                          ])
                    ])
              ])
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.brandTemplate === "generic_2"
        ? _c(
            "div",
            { staticClass: "acc_page_bgr_img" },
            [_c("icon", { attrs: { name: "icon-w2g" } })],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ea2b073", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea2b073","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/W2GTaxFormList.vue
// module id = null
// module chunks = 